import styled from "styled-components";
import colors from "../../../styles/colorPalette";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${colors.gray1};
  overflow-y: overlay;
  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #dcdcdc;
    border-radius: 4px;
  }
`;

export const HeaderContainer = styled.div``;

export const FormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 52px;
  padding-bottom: 135px;
  @media (max-width: 1400px) {
    padding-bottom: 41px;
  }
`;
